import { render, staticRenderFns } from "./add-manager.vue?vue&type=template&id=f99fc3b8&scoped=true&lang=pug"
import script from "./add-manager.vue?vue&type=script&lang=js"
export * from "./add-manager.vue?vue&type=script&lang=js"
import style0 from "./add-manager.vue?vue&type=style&index=0&id=f99fc3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99fc3b8",
  null
  
)

export default component.exports